import { lgMarginBottomStyles } from "../../neutral/styles/spacing";
import { SmallDivider } from "@minted/fancyclothes";
import React from "react";

const centered = {
  textAlign: "center",
};

const marginTop = {
  marginTop: "2rem",
};

const PageContentSeparator = ({ extraStyles = [], isCentered }) => (
  <div
    css={[
      lgMarginBottomStyles,
      marginTop,
      isCentered && centered,
      ...(Array.isArray(extraStyles) ? extraStyles : [extraStyles]),
    ]}
    data-cy="secondarySeparator"
  >
    <SmallDivider />
  </div>
);

PageContentSeparator.displayName = "PageContentSeparator";

export default PageContentSeparator;
